/**
 * assets/loft-showcase.js
 *
 * Comportamiento de "Loft — Producto destacado" (sections/loft-showcase.liquid). NUEVO Y
 * AISLADO: no importa ni depende de assets/loft-configurador-accesorio.js (el de la ficha de
 * producto) — ese archivo sigue intacto. Sí replica, a propósito, la MISMA forma final del
 * carrito que produce la ficha, para que agregar desde el Home o desde la ficha sea indistinguible
 * una vez el producto está en el carrito:
 *
 *   Línea 1: variante de la cama, cantidad 1, con properties[<propertyName>] = etiqueta del
 *            nochero elegido (+ " x2" si la cantidad es 2). Si no se eligió nochero, sin properties.
 *   Línea 2 (solo si hay nochero elegido): variante del nochero, cantidad elegida (1 o 2), con
 *            properties._loft_config_de = propertyName.
 *
 * Esas son exactamente las mismas claves/valores que usa snippets/loft-configurador-accesorio.js
 * en la ficha (ver ese archivo). A diferencia de la ficha —que hace dos llamadas a /cart/add.js
 * en cadena porque depende del <product-form> nativo de Dawn— aquí no existe ese formulario, así
 * que se hace UNA sola llamada con ambas líneas en el mismo body. El resultado en el carrito es
 * idéntico.
 */
(function () {
  function money(str) {
    return str || '';
  }

  function initShowcase(root) {
    var sectionId = root.id.replace('loft-showcase-', '');
    var metaEl = root.querySelector('[data-loft-showcase-meta]');
    var meta = {};
    try {
      meta = JSON.parse(metaEl.textContent);
    } catch (e) {
      /* noop */
    }

    var priceEl = root.querySelector('[data-loft-showcase-price]');
    var errorEl = root.querySelector('[data-loft-showcase-error]');
    var addBtn = root.querySelector('[data-loft-showcase-add]');

    /* ---------- Galería ---------- */
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-loft-showcase-slide]:not(.loft-showcase__slide--override)'));
    var overrideSlide = root.querySelector('[data-loft-showcase-override]');
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-loft-showcase-dot]'));
    var prevBtn = root.querySelector('[data-loft-showcase-prev]');
    var nextBtn = root.querySelector('[data-loft-showcase-next]');
    var baseSlideCount = slides.length;
    var activeIndex = 0;

    function clearOverride() {
      if (overrideSlide) {
        overrideSlide.classList.remove('is-active');
      }
    }

    function showIndex(index) {
      if (baseSlideCount === 0) return;
      activeIndex = (index + baseSlideCount) % baseSlideCount;
      slides.forEach(function (slide, i) {
        slide.classList.toggle('is-active', i === activeIndex);
      });
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === activeIndex);
      });
      clearOverride();
    }

    function showOverride(imageUrl) {
      if (!overrideSlide || !imageUrl) return;
      if (overrideSlide.getAttribute('src') !== imageUrl) {
        overrideSlide.setAttribute('src', imageUrl);
      }
      overrideSlide.classList.add('is-active');
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        showIndex(activeIndex - 1);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        showIndex(activeIndex + 1);
      });
    }
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        showIndex(parseInt(dot.dataset.index, 10));
      });
    });

    /* ---------- Tamaño ---------- */
    var sizeButtons = Array.prototype.slice.call(root.querySelectorAll('[data-loft-showcase-size]'));
    var currentBedVariantId = meta.baseVariantId ? String(meta.baseVariantId) : (sizeButtons[0] ? sizeButtons[0].dataset.variantId : null);

    sizeButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        sizeButtons.forEach(function (b) {
          b.classList.remove('is-selected');
        });
        btn.classList.add('is-selected');
        currentBedVariantId = btn.dataset.variantId;
        clearError();
        refreshTotal();
      });
    });

    /* ---------- Configurador de accesorio (nochero) ---------- */
    var configRoot = root.querySelector('[data-loft-showcase-config]');
    var configMeta = { basePriceByVariant: {}, options: [], propertyName: 'Accesorio' };
    var cards = [];
    var qtyWrap = null;
    var qtyButtons = [];
    var optionsByVariantId = {};

    var selectedAccessoryVariantId = '';
    var selectedAccessoryLabel = '';
    var selectedQuantity = 0;

    if (configRoot) {
      var configMetaEl = configRoot.querySelector('[data-loft-showcase-config-meta]');
      try {
        configMeta = JSON.parse(configMetaEl.textContent);
      } catch (e) {
        configMeta = { basePriceByVariant: {}, options: [], propertyName: 'Accesorio' };
      }
      (configMeta.options || []).forEach(function (opt) {
        optionsByVariantId[opt.variantId] = opt;
      });

      cards = Array.prototype.slice.call(configRoot.querySelectorAll('[data-loft-showcase-card]'));
      qtyWrap = configRoot.querySelector('[data-loft-showcase-qty]');
      qtyButtons = Array.prototype.slice.call(configRoot.querySelectorAll('[data-loft-showcase-qty-btn]'));

      var setQtyUI = function (card) {
        if (!qtyWrap) return;
        var hasAccessory = !!card.dataset.variantId;
        qtyWrap.hidden = !hasAccessory;
        if (!hasAccessory) return;
        var maxQty = parseInt(card.dataset.maxQty || '2', 10);
        qtyButtons.forEach(function (btn) {
          var qty = parseInt(btn.dataset.qty, 10);
          btn.disabled = qty > maxQty;
        });
        if (selectedQuantity > maxQty || selectedQuantity < 1) selectedQuantity = 1;
        qtyButtons.forEach(function (btn) {
          btn.classList.toggle('is-selected', parseInt(btn.dataset.qty, 10) === selectedQuantity);
        });
      };

      var selectCard = function (card) {
        cards.forEach(function (c) {
          c.classList.remove('is-selected');
          c.setAttribute('aria-selected', 'false');
        });
        card.classList.add('is-selected');
        card.setAttribute('aria-selected', 'true');
        clearError();

        selectedAccessoryVariantId = card.dataset.variantId || '';
        selectedAccessoryLabel = card.dataset.label || '';
        selectedQuantity = selectedAccessoryVariantId ? 1 : 0;

        setQtyUI(card);

        if (selectedAccessoryVariantId && card.dataset.image) {
          showOverride(card.dataset.image);
        } else {
          clearOverride();
        }

        refreshTotal();
      };

      cards.forEach(function (card) {
        card.addEventListener('click', function () {
          if (card.disabled) return;
          selectCard(card);
        });
      });

      qtyButtons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (btn.disabled) return;
          selectedQuantity = parseInt(btn.dataset.qty, 10);
          qtyButtons.forEach(function (b) {
            b.classList.toggle('is-selected', b === btn);
          });
          refreshTotal();
        });
      });
    }

    /* ---------- Precio total ---------- */
    function refreshTotal() {
      if (!priceEl || !currentBedVariantId) return;
      var text;
      if (selectedAccessoryVariantId && optionsByVariantId[selectedAccessoryVariantId]) {
        var byVariant = optionsByVariantId[selectedAccessoryVariantId].priceByVariant[currentBedVariantId];
        text = byVariant && byVariant[String(selectedQuantity)];
      } else {
        text = configMeta.basePriceByVariant && configMeta.basePriceByVariant[currentBedVariantId];
      }
      if (text) priceEl.textContent = money(text);
    }

    /* ---------- Errores ---------- */
    function clearError() {
      if (!errorEl) return;
      errorEl.hidden = true;
      errorEl.textContent = '';
    }
    function showError(message) {
      if (!errorEl) return;
      errorEl.textContent = message;
      errorEl.hidden = false;
    }

    /* ---------- Agregar al carrito (una sola llamada, mismas líneas que la ficha) ---------- */
    var pendingAdd = false;

    function addToCart() {
      if (pendingAdd || !currentBedVariantId) return;
      pendingAdd = true;
      clearError();
      if (addBtn) addBtn.disabled = true;

      var items = [{ id: currentBedVariantId, quantity: 1 }];

      if (selectedAccessoryVariantId && selectedQuantity > 0) {
        var propertyName = configMeta.propertyName || 'Accesorio';
        var label = selectedAccessoryLabel;
        if (selectedQuantity > 1) label += ' x' + selectedQuantity;
        var props = {};
        props[propertyName] = label;
        items[0].properties = props;

        var accessoryProps = {};
        accessoryProps['_loft_config_de'] = propertyName;
        items.push({
          id: selectedAccessoryVariantId,
          quantity: selectedQuantity,
          properties: accessoryProps,
        });
      }

      var cartComponent = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      var body = { items: items };
      if (cartComponent && typeof cartComponent.getSectionsToRender === 'function') {
        body.sections = cartComponent.getSectionsToRender().map(function (s) {
          return s.id;
        });
        body.sections_url = window.location.pathname;
      }

      fetch(window.routes ? window.routes.cart_add_url : '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (response) {
          if (response && response.status) {
            showError(
              'No pudimos agregar esta combinación al carrito: ' +
                (response.description || response.message || 'sin stock suficiente') +
                '. Puedes intentarlo desde la ficha del producto.'
            );
            return;
          }

          // El pedido YA se agregó correctamente en este punto (el fetch anterior no falló y
          // la respuesta no trae `status` de error). Todo lo que sigue es solo refrescar la UI
          // del carrito (drawer/notification) — un fallo aquí no debe reportarse como "no se
          // pudo agregar", porque sí se agregó. Se aisla en su propio try/catch para no activar
          // el mensaje de error de conexión por un problema puramente de refresco visual.
          try {
            if (cartComponent && typeof cartComponent.renderContents === 'function') {
              cartComponent.renderContents(response);
            } else if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'loft-showcase', cartData: response });
            }
          } catch (renderErr) {
            console.error('loft-showcase: se agregó al carrito pero no se pudo refrescar el drawer', renderErr);
          }
        })
        .catch(function (err) {
          showError('Hubo un problema de conexión al agregar al carrito. Intenta de nuevo.');
          console.error('loft-showcase: error al agregar al carrito', err);
        })
        .finally(function () {
          pendingAdd = false;
          if (addBtn) addBtn.disabled = false;
        });
    }

    if (addBtn) {
      addBtn.addEventListener('click', addToCart);
    }

    refreshTotal();
  }

  function init() {
    document.querySelectorAll('[data-loft-showcase]').forEach(initShowcase);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
